import { UserTypeEnum } from 'enums';

export function getTabItems(user, billingHistory, tabItems) {
  const isLabResearcherMember = user.team !== 1 && user.tp_user !== UserTypeEnum.LAB_RESEARCHER;

  if (!billingHistory.length) {
    return tabItems.filter((item) => {
      return !['Credit Card Details', 'Billing History'].includes(item.label);
    });
  }

  const stripeTypes = ['Stripe', 'Stripe BR'];

  const isStripeMethod = billingHistory.some((invoice) => {
    return stripeTypes.includes(invoice.gateway);
  });

  if (!isStripeMethod) {
    return tabItems.filter((item) => item.label !== 'Credit Card Details');
  }

  if (isLabResearcherMember) {
    return tabItems.filter((item) => item.label === 'My Plan');
  }

  return tabItems;
}
